import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M98.919 61.191a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M101.419 84.83a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6.566 62.34a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M83.215 97.744a1.5 1.5 0 0 1 0 2.121l-9.994 9.994a1.5 1.5 0 1 1-2.122-2.121l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M71.1 97.744a1.5 1.5 0 0 1 2.12 0l9.995 9.994a1.5 1.5 0 1 1-2.122 2.121L71.1 99.865a1.5 1.5 0 0 1 0-2.121M26.44 7.724a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 1 1-3 0V9.224a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M17.873 16.29a1.5 1.5 0 0 1 1.5-1.5h14.134a1.5 1.5 0 1 1 0 3H19.373a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#8F9BA8"
      d="M90.689 38.751H21.943a2.345 2.345 0 0 0-2.345 2.345V54.86a2.345 2.345 0 0 0 2.345 2.345h68.746a2.345 2.345 0 0 0 2.345-2.345V41.096a2.345 2.345 0 0 0-2.345-2.345"
    />
    <path
      fill="#C7D0D9"
      d="M26.636 57.205H86.82v32.81a2.577 2.577 0 0 1-2.576 2.576H29.212a2.577 2.577 0 0 1-2.576-2.576z"
    />
    <path fill="#7B8493" d="M62.103 38.751H51.352v53.84h10.75z" />
    <path
      fill="#7B8493"
      d="M79.27 27.63c-1.08-3.23-3.98-5.34-7.77-5.64-4.35-.35-8.53 1.79-10.36 5.31-1.71 3.29-3.37 6.31-4.37 8.1-.85-1.51-2.84-5.08-4.91-9.05-1.83-3.52-6-5.65-10.36-5.31-3.79.3-6.69 2.4-7.77 5.64-1.23 3.69-.9 7.13.93 9.66 1.3 1.8 3.95 3.95 9.2 3.95s8.7-.36 10.48-.6l-.09.15 3.09.59c.17.03 4.26.8 11.81.8 5.25 0 7.9-2.15 9.2-3.95 1.83-2.54 2.16-5.97.93-9.66zm-35.41 8.16c-1.85 0-4.31-.36-5.55-2.08-.96-1.33-1.07-3.32-.31-5.61.7-2.11 2.93-2.51 3.85-2.58.17-.01.34-.02.52-.02 2 0 4.43.88 5.5 2.93 1.4 2.69 2.77 5.21 3.78 7.04-1.84.17-4.46.33-7.79.33zm30.83-1.13c-1.24 1.72-3.7 2.08-5.55 2.08-3.35 0-5.96-.16-7.79-.32 1.01-1.83 2.38-4.35 3.78-7.04 1.16-2.23 3.94-3.07 6.02-2.91.92.07 3.15.47 3.85 2.58.76 2.29.65 4.28-.31 5.61"
    />
  </svg>
);
const SvgEnrichedIconGiftGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconGiftGreyscale);
export default Memo;
